/*
 * @Author: qiankun 153087222@qq.com
 * @Date: 2023-03-30 10:41:11
 * @LastEditors: qiankun 153087222@qq.com
 * @LastEditTime: 2023-07-24 09:26:42
 * @FilePath: /qcsdjyBigdataUI/src/api/common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/tool/request";
const api = {
  getWeather(params) {
    return request({
      url: "/qdBigData/weather/realTimeWeather",
      method: "get",
      params,
    });
  },
  getVideoSource(params) {
    return request({
      url: "/qdVideoSurve/videoSurveillance/getPassengerFlowOfTheDay",
      method: "get",
      params,
    });
  },
  login(params) {
    return request({
      url: "/qdBigData/sys/login",
      method: "get",
      params,
    });
  },
};

export default api;
